import React, { memo } from "react";
import { useSelector } from "react-redux";
import { Menu } from "lucide-react";
import { Nav, Navbar, Button, NavbarBrand } from "reactstrap";
import { DOCTOR_ROLE } from "../../utils/constants";

const Topbar = ({ toggleSidebar, setToggleSidebar }) => {
  const { user } = useSelector((state) => state.user);

  return (
    <>
      <Navbar className={`navbar transition px-3 d-flex align-items-center`}>
        <NavbarBrand>
          <Button
            data-testid="topbar-sidebar-toggle"
            className="btn cursor-pointer bg-transparent border-0 text-dark"
            onClick={() => setToggleSidebar(!toggleSidebar)}
          >
            <Menu size={20} />
          </Button>
        </NavbarBrand>
        {user?.role === DOCTOR_ROLE && (
          <Nav className="ml-auto d-flex align-items-center gap-4">
            <div className="grayBg px-3 border-0 shadow-sm customBorderRadius fw-bold d-flex align-items-center gap-3 text-secondary py-1 px-4">
              <span className="p-3 seaGreenBg customBorderRadius"></span>
              {user?.defaultPractice?.name}
            </div>
          </Nav>
        )}
      </Navbar>
    </>
  );
};

export default memo(Topbar);
